import systemRequest from '@/services/admin/system-service';
let cached = null;
export const systemConfigService = {
    async fetch() {
        if (cached)
            return cached;
        const response = isGlobalPlatformContext()
            ? await systemRequest.find(1)
            : await systemRequest.runtimePricing();
        if (response.status === 200 && response.data) {
            const value = response.data.emanta_commission_percentage;
            if (value === null || value === undefined) {
                cached = null;
                return null;
            }
            cached = {
                emantaCommissionRate: Number(value),
                chargePercentageCompoundingEnabled: response.data.charge_percentage_compounding_enabled === true,
                customerIvaEnabled: response.data.customer_iva_enabled !== false,
                customerIvaRate: Number(response.data.customer_iva_rate ?? 0.13),
                emantaCommissionIvaRate: Number(response.data.emanta_commission_iva_rate ?? 0.13),
            };
            return cached;
        }
        return null;
    },
    invalidateCache() {
        cached = null;
    },
    getCached() {
        return cached;
    },
};
function isGlobalPlatformContext() {
    return localStorage.getItem('role_key') === 'platform_owner'
        && !localStorage.getItem('org_id');
}
export default systemConfigService;
